import { createIcon } from "@chakra-ui/react";

const DoneIcon = createIcon({
  displayName: "DoneIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM4.5 19.5H19.5V4.5H4.5V19.5ZM17.0605 9.53027L10.5303 16.0605L7 12.5303L8.06055 11.4697L10.5303 13.9395L16 8.46973L17.0605 9.53027Z"
      fill="currentColor"
    />
  ),
});

export default DoneIcon;
